import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { InstanceDataService } from '../../../../../../services/instance-data.service';
import { AllowedItem } from '../../../../models/informate/allowed-item';
import { AllowedItemChange, BreadcrumbData } from '../instance-configuration/instance-configuration.component';

@Component({
    selector: 'app-instance-data',
    templateUrl: './instance-data.component.html',
    styleUrls: ['./instance-data.component.scss'],
})
export class InstanceDataComponent implements OnInit {
    @Input()
    set allowedItem(value: AllowedItem[]) {
        if (value !== null && value !== undefined) {
            this._allowedItem = value;
            this.allowedItemsToDisplay = value;
            this.cd.markForCheck();
        }
    }
    get allowedItem(): AllowedItem[] {
        return this._allowedItem;
    }

    @Input()
    set breadcrumbData(value: BreadcrumbData[]) {
        if (value !== null && value !== undefined) {
            this._breadcrumbData = value;
            this.cd.markForCheck();
        }
    }
    get breadcrumbData(): BreadcrumbData[] {
        return this._breadcrumbData;
    }

    @Output() selectItemClick = new EventEmitter<any>();
    @Output() refreshClick = new EventEmitter<any>();
    @Output() dataChangeEvent: EventEmitter<AllowedItemChange> = new EventEmitter();

    private _allowedItem: AllowedItem[];
    public _breadcrumbData: BreadcrumbData[];
    public selectAll: boolean = false;
    allowedItemsToDisplay: AllowedItem[];

    constructor(
        private cd: ChangeDetectorRef,
        private instanceDataService: InstanceDataService
    ) {}

    ngOnInit(): void {}

    selectionChange(event: MatCheckboxChange, allowedItem: AllowedItem) {
        let idArray = this.breadcrumbData.map((a) => a.id);
        if (idArray[idArray.length - 1] != allowedItem.itemId) {
            idArray.push(allowedItem.itemId);
        }
        this.dataChangeEvent.emit({ itemIds: idArray, allowed: event.checked });
        if (this.checkAllowedItemUpdate(this.allowedItemsToDisplay, false) != true) {
            this.selectAll = true;
            this.dataChangeEvent.emit({ itemIds: idArray, allowed: event.checked });
        } else {
            this.selectAll = false;
            this.dataChangeEvent.emit({ itemIds: idArray, allowed: event.checked });
        }
        this.dataChangeEvent.emit({ itemIds: idArray, allowed: event.checked });
    }

    checkAllowedItemUpdate(ItemsToDisplay: any[], flag: boolean): boolean {
        for (let i = 0; i < ItemsToDisplay.length; i++) {
            if (ItemsToDisplay[i].items?.length > 0) {
                if (this.checkAllowedItemUpdate(ItemsToDisplay[i].items, flag)) return true;
            } else {
                if (ItemsToDisplay[i].allowed != true) return true;
            }
        }
    }

    selectionChangeAll(event: MatCheckboxChange) {
        this.getAllowedItemUpdate(this.allowedItemsToDisplay, event.checked);
    }

    getAllowedItemUpdate(ItemsToDisplay: any[], status: boolean) {
        for (let i = 0; i < ItemsToDisplay.length; i++) {
            if (ItemsToDisplay[i].items?.length > 0) {
                this.getAllowedItemUpdate(ItemsToDisplay[i].items, status);
            } else {
                ItemsToDisplay[i].allowed = status;
            }
        }
        this.selectAll = status;
    }

    loadData(allowedItem: AllowedItem) {
        let selected = this.allowedItemsToDisplay.find((x) => x.itemId == allowedItem.itemId);
        //if there are sub items
        if (selected?.items != null) {
            let layer = this.instanceDataService.currentLayer.getValue();
            if (this.breadcrumbData?.length > layer) {
                let _BreadCrumbData = [];
                for (let i = 0; i < this.breadcrumbData.length; i++) {
                    //initial data  i=0;
                    if (i < layer) {
                        _BreadCrumbData.push(this.breadcrumbData[i]);
                    }
                }
                this.breadcrumbData = _BreadCrumbData;
            }
            const index = this.breadcrumbData.findIndex((x) => x.id === allowedItem.itemId);
            if (index >= 0) {
                this.breadcrumbData.splice(index, 1);
            }

            this.breadcrumbData.push({ id: selected.itemId, name: selected.name, layer: this.instanceDataService.currentLayer.getValue() });

            this.allowedItemsToDisplay = selected.items;
            this.selectItemClick.emit(allowedItem);
        }
    }

    _LoadFeatures(data: AllowedItem[]) {
        this.allowedItem = data;
    }

    loadDataBySelected(allowedItem: AllowedItem) {
        let layer = this.instanceDataService.currentLayer.getValue();
        if (allowedItem?.items != null) {
            if (this.breadcrumbData?.length >= layer) {
                let _BreadCrumbData = [];
                for (let i = 0; i < this.breadcrumbData.length; i++) {
                    //initial data  i=0;
                    if (i < layer) {
                        _BreadCrumbData.push(this.breadcrumbData[i]);
                    }
                }
                this.breadcrumbData = _BreadCrumbData;
            }
            const index = this.breadcrumbData.findIndex((x) => x.id === allowedItem.itemId);
            if (index >= 0) {
                this.breadcrumbData.splice(index, 1);
            }
            const index1 = this.breadcrumbData.findIndex((x) => x.layer === layer);
            if (index1 >= 0 && layer != undefined) {
                this.breadcrumbData.splice(index1, 1);
            }

            this.breadcrumbData.push({ id: allowedItem.itemId, name: allowedItem.name, layer: layer });
            //this.allowedItem = selected.items;
            this.allowedItemsToDisplay = allowedItem.items;
        } else {
            this.allowedItemsToDisplay = [allowedItem];
        }
    }

    refreshData(data: any) {
        let id = data.id;
        let selected: AllowedItem[];
        let tempbreadcrumbData: BreadcrumbData[] = [];
        for (let i = 0; i < this.breadcrumbData.length; i++) {
            //initial data  i=0;
            if (i == 0) {
                selected = this.allowedItem;
                tempbreadcrumbData.push(this.breadcrumbData[i]);
            } else {
                selected = selected.find((x) => x.itemId == this.breadcrumbData[i].id).items;
                tempbreadcrumbData.push(this.breadcrumbData[i]);
            }
            if (this.breadcrumbData[i].id == id) {
                break;
            }
        }
        this.breadcrumbData = tempbreadcrumbData;
        this.allowedItemsToDisplay = selected;
        this.instanceDataService.currentLayer.next(data.layer);
        this.refreshClick.emit(id);
    }

    getGroupCheckedStatus(allowedItem: AllowedItem): boolean {
        //level 0
        if (allowedItem.items == undefined || allowedItem.items == null) {
            return allowedItem.allowed;
        }
        //level 1
        else if (allowedItem.items.every((x) => x.items == undefined)) {
            return allowedItem.items.every((x) => x.allowed == true);
        }
        //level 2
        else return allowedItem.items.every((x) => x.items.every((y) => y.allowed == true) == true);
    }

    getPartiallySelectedGroupCheckedStatus(allowedItem: AllowedItem): boolean {
        //level 0
        if (allowedItem.items == undefined || allowedItem.items == null) {
            return false;
        }
        //level 1
        else if (allowedItem.items.every((x) => x.items == undefined)) {
            const result = allowedItem.items.some((child) => child.allowed == true);
            const result1 = allowedItem.items.some((child) => child.allowed == false);
            return result && result1 ? true : false;
        }
    }
}
